import React from 'react';

export default React.createContext({
  token: sessionStorage.getItem('sp_token'),
  user: JSON.parse(sessionStorage.getItem('sp_current_user')),
  login: () => {},
  logout: () => {}
})
